import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../context/AppContext";
import Footer from "./Common_Components/Footer";

function ThankYouQuiz() {
    const [activePage, setActivePage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
    const { Translate } = useContext(ProductContext);
    const ThankYouQuizData = location.state;
    const categoryId = ThankYouQuizData?.categoryId;
    const dayId = ThankYouQuizData?.dayId;
    const is_review = ThankYouQuizData?.is_review;
    const examId = ThankYouQuizData?.examId;
    const selectedExamId = ThankYouQuizData?.selectedExamId;
    const screenTitleId = ThankYouQuizData?.screenTitleId || localStorage.getItem("screenTitleId") || localStorage.getItem("LearningJourneyActiveScreenId");
    const unique_day_id = ThankYouQuizData?.unique_day_id || ThankYouQuizData?.ModuleId;
    const resolvedUniqueDayId = unique_day_id || dayId || categoryId;
    const backRoute = location.state?.from || "/learning-journey";

    const { LearningId, categoryName, total_time_spent, methodType, examTypes } = location.state || {};

    console.log(examTypes, "examTypes ThankYouQuiz")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);

    const handleNext = async () => {
        try {
            const token = localStorage.getItem("AuthToken");
            const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
            const examIdVal = examId || selectedExamId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
            if (token && categoryId && LearningId && screenTitleId && examIdVal && resolvedUniqueDayId) {
                await fetch(`${baseUrl}/api/user-visits/finish-visit`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: resolvedUniqueDayId,
                        unique_day_id: resolvedUniqueDayId,
                        learning_method_id: LearningId,
                        screen_title_id: screenTitleId,
                        examId: examIdVal,
                    }),
                });
            }
        } catch (error) {
            console.error("Error calling finish-visit in ThankYouQuiz:", error);
        }

        const examIdVal = examId || selectedExamId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
        navigate("/new-learning-journey", {
            state: {
                selectedExamId: examIdVal,
                examId: examIdVal,
                examTypes: examTypes || [],
            },
        });
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                             <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey', { state: { selectedExamId: examId || selectedExamId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId"), examTypes: examTypes || [] } })} className='icon_1' />
                            <h2></h2>  {/* Display the selected day */}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="thank-you-quiz-container">
                <div className="thank-you-content">
                    <h3>やったー！</h3>

                    <h2>{Translate?.message?.data?.youveCompletedTheQuiz || "You've Completed the Quiz!"}</h2>

                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/finishquiz.png`}
                        className="thank-you-quiz-img"
                    />

                    {(ThankYouQuizData?.correctCount !== undefined ||
                      ThankYouQuizData?.incorrectCount !== undefined ||
                      ThankYouQuizData?.skippedCount !== undefined) && (
                        <div className="resultDetails" style={{ margin: "20px auto", width: "100%", maxWidth: "320px", background: "rgba(255,255,255,0.8)", borderRadius: "12px", padding: "15px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
                            <div className="quiz-result-menu-item" style={{ display: "flex", justifyContent: "space-between", padding: "10px 5px", borderBottom: "1px solid #eee" }}>
                                <span className="quiz-result-menu-text" style={{ fontWeight: "600", color: "#333" }}>{Translate?.message?.data?.correct || "Correct"}</span>
                                <span className="quiz-result-menu-number" style={{ color: "#4CAF50", fontWeight: "700", fontSize: "1.1rem" }}>{ThankYouQuizData?.correctCount || 0}</span>
                            </div>
                            <div className="quiz-result-menu-item" style={{ display: "flex", justifyContent: "space-between", padding: "10px 5px", borderBottom: "1px solid #eee" }}>
                                <span className="quiz-result-menu-text" style={{ fontWeight: "600", color: "#333" }}>{Translate?.message?.data?.incorrect || "Incorrect"}</span>
                                <span className="quiz-result-menu-number" style={{ color: "#F44336", fontWeight: "700", fontSize: "1.1rem" }}>{ThankYouQuizData?.incorrectCount || 0}</span>
                            </div>
                            <div className="quiz-result-menu-item" style={{ display: "flex", justifyContent: "space-between", padding: "10px 5px" }}>
                                <span className="quiz-result-menu-text" style={{ fontWeight: "600", color: "#333" }}>{Translate?.message?.data?.skipped || "Skipped"}</span>
                                <span className="quiz-result-menu-number" style={{ color: "gray", fontWeight: "700", fontSize: "1.1rem" }}>{ThankYouQuizData?.skippedCount || 0}</span>
                            </div>
                        </div>
                    )}

                    <div className="thank-you-quiz-button-group">
                        <button
                            className="thank-you-quiz-button"
                            onClick={handleNext}
                        >
                            {Translate?.message?.data?.next || "Next"}
                        </button>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <Footer />
        </div>
    );
}

export default ThankYouQuiz;
